export default __webpack_public_path__ + "static/media/pcb_type.160c0ca3.svg";